import { useState, useEffect } from 'react';
import axios from '../api/axios';
import useAxiosFunction from '../hooks/useAxiosFunction';

import styles from '../styles/recruitmentHome.module.scss';

import Pagination from '@mui/material/Pagination';

import HeroBanner from '../components/HeroBanner';
import JobSearchBar from '../components/JobSearchBar';
import JobAdvertGrid from '../components/JobAdvertGrid';

export default function Home() {

    const [jobAdverts, setJobAdverts] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [searchQuery, setSearchQuery] = useState("");

    const [response, error, loading, axiosFetch] = useAxiosFunction();

    const itemsPerPage = 9;

    /**
     * Load adverts whenever the page changes.
     */
    useEffect(() => {
        populateJobAdverts(currentPage, searchQuery);
    }, [currentPage]);

    /**
     * Update state after a successful API call.
     */
    useEffect(() => {
        if (response != null) {
          console.log(response)
            setJobAdverts(response.content);
            setTotalPages(response.totalPages);
        }
    }, [response]);

    /**
     * Debounced searching.
     */
    useEffect(() => {

        const timeout = setTimeout(() => {

            if (currentPage !== 0) {
                setCurrentPage(0);
            } else {
                populateJobAdverts(0, searchQuery);
            }
        }, 400);

        return () => clearTimeout(timeout);

    }, [searchQuery]);

    const populateJobAdverts = async (page, search) => {

        try {

            await axiosFetch({
                axiosInstance: axios,
                method: 'get',
                url: `/job-adverts?page=${page}&size=${itemsPerPage}&search=${encodeURIComponent(search)}`
            });

        } catch (err) {
            console.log(err);
        }

    };

    return (

        <div className={styles.page}>
            <HeroBanner />
            <div className={styles.container}>

                

                <JobSearchBar
                    query={searchQuery}
                    setQuery={setSearchQuery}
                />

                <div className={styles.section}>

                    <JobAdvertGrid adverts={jobAdverts} />

                    <Pagination
                        className={styles.paginationContainer}
                        count={totalPages}
                        variant="outlined" shape="rounded" showFirstButton showLastButton 
                        page={currentPage + 1}
                        color="primary"
                        onChange={(event, value) => {
                            setCurrentPage(value - 1);
                        }}
                    />

                </div>

            </div>

        </div>

    );

}